<h2>Event Attributes</h2>

<div
  class="actions-bar"
  fxLayout="row"
  fxLayoutAlign="stretch center"
  fxLayoutGap="12px"
  fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="stretch stretch"
>
  <mat-form-field appearance="outline" fxFlex fxFlex.lt-md="100">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      type="text"
      (input)="onSearch($event)"
      placeholder="Search attributes..."
      #searchInput
      [formControl]="searchControl"
    />
    <button
      type="button"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      *ngIf="searchInput.value"
      (click)="clearSearch()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <button
    #filterToggleButton
    type="button"
    mat-stroked-button
    matTooltip="Show/hide filters"
    (click)="toggleFilters()"
  >
    <mat-icon>filter_alt</mat-icon>
  </button>
</div>

<ng-container *ngIf="viewModel$ | async as viewModel">
  <mat-sidenav-container>
    <mat-sidenav #filterSidenav mode="over" position="end" class="filter-drawer">
      <mat-toolbar>
        Filter
        <span class="menu-spacer"></span>
        <button
          type="button"
          mat-icon-button
          aria-label="Close filter menu"
          matTooltip="Close filter menu"
          (click)="filterSidenav.toggle()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>
      <div style="margin: 16px">
        <div fxLayout="column">
          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Division</mat-label>
            <mat-select
              multiple
              [formControl]="divisionFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option *ngFor="let division of divisionOptions" [value]="division.id">
                {{ division.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Attribute Type</mat-label>
            <mat-select
              multiple
              [formControl]="attributeTypeFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option *ngFor="let attributeType of attributeTypeOptions" [value]="attributeType.id">
                {{ attributeType.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-select-field">
            <mat-label>Event Type</mat-label>
            <mat-select
              multiple
              [formControl]="eventTypeFilterControl"
              (selectionChange)="onFilterChange()"
            >
              <mat-option *ngFor="let eventType of eventTypeOptions" [value]="eventType.id">
                {{ eventType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
          <button type="button" mat-stroked-button (click)="resetFilters()">Reset</button>
          <button type="button" mat-raised-button color="accent" (click)="applyFilters()">
            Apply
          </button>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <table
        *ngIf="viewModel.attributes.length"
        mat-table
        [dataSource]="viewModel.attributes"
        matSort
        matSortActive="Name"
        matSortDirection="asc"
        matSortDisableClear
        (matSortChange)="onSort($event)"
      >
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name" [resizeColumn]="true">
            Name
          </th>
          <td mat-cell *matCellDef="let record">{{ record.Detail?.PrintAttributeName }}</td>
        </ng-container>

        <ng-container matColumnDef="EventTypeNames">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Event Type" [resizeColumn]="true">
            Event Type
          </th>
          <td mat-cell *matCellDef="let record">{{ record.EventTypeNames || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="PrintAttributeType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Attribute Type" [resizeColumn]="true">
            Attribute Type
          </th>
          <td mat-cell *matCellDef="let record">
            <span
              class="attr-type-pill"
              [ngClass]="'print-attr-tone--' + printAttrToneSlug(record.Detail?.PrintAttributeType)"
              *ngIf="record.Detail?.PrintAttributeType as attrType"
            >
              {{ attrType }}
            </span>
            <span *ngIf="!record.Detail?.PrintAttributeType">-</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Description" [resizeColumn]="true">
            Description
          </th>
          <td mat-cell *matCellDef="let record">{{ record.Detail?.Description || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="DivisionNames">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Division</th>
          <td mat-cell *matCellDef="let record">{{ record.DivisionNames || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="Versions">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Version(s)</th>
          <td mat-cell *matCellDef="let record">{{ versionsDisplay(record) }}</td>
        </ng-container>

        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Actions</th>
          <td mat-cell *matCellDef="let record">
            <button
              type="button"
              mat-icon-button
              matTooltip="Edit values"
              (click)="edit(record)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <table *ngIf="!viewModel.attributes.length">
        <tr>
          <td class="no-records" [attr.colspan]="displayedColumns.length">
            <h2>No Records Found</h2>
          </td>
        </tr>
      </table>

      <mat-paginator
        *ngIf="viewModel.attributes.length"
        [pageSizeOptions]="[5, 10, 20, 50, 100]"
        [pageSize]="viewModel.page.pageSize"
        [length]="viewModel.totalRecords"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
